<template>
    <div class="opportunity-list">
        <Paper class="opportunity-list-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="contractList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.opportunityTransfer"
                        type="primary"
                        icon="el-icon-refresh"
                        size="mini"
                        title="转移"
                        @click="handleTransfer">转移
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.opportunityListExport"
                        type="primary"
                        size="mini"
                        title="导出">
                        <span @click="handleExport">导出</span>
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="refresh"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                        icon="iconfont icon-list_install"
                        type="primary"
                        size="mini"
                        :title="'列配置'"
                        @click="showColumnConfigDialog"
                        plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="clientOrder"
                        :height="tableHeight"
                        v-loading="contractList.tableLoading"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.tableData.columns"
                        @selection-change="contractList.handleSelectedRow"
                        :rows="contractList.totalData">
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'businessCategory'">{{ codesToNames(row[col.prop],
                                        dictDatas[col.optionsKey]) }}</div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="contractList.sizeChange"
                        :current-page.sync="contractList.pageNo"
                        @current-change="contractList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="contractList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.tableData.columns"
                ref="otpColumnConfig"
                @header-change="config.tableData.columns = $event"
            />
            <transfer-dialog ref="transferDialogRef" @confirm="saveHandle" />
        </Paper>
    </div>
</template>
<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import { opportunityInfoPageApi, queryOpportunityRelation, saveOpportunityTransfer, opportunityListExport } from '@mdm/api/opportunityModules/opportunityList.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import transferDialog from './component/Index.vue';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { Message } from 'element-ui';
export default {
    name: 'customer',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig,
        transferDialog
    },
    props: {},
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.opportunity);
        const { user } = store.getters;
        const config = reactive(configStatic);
        class ContractListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const contractList = new ContractListClass({
            Api: {
                listApi: opportunityInfoPageApi // 查询接口
            }
        });
        const dictDatas = ref({});
        onMounted(async() => {
            dictDatas.value = await otherUtils.getDictDataList(config.tableData.columns);
            setupContext.refs.searchBox.submitSearch();
        });
        const refresh = () => {
            contractList.getList();
        };
        const searchDataFormat = (condition) => {
            if (condition.selectList && condition.selectList.length) {
                condition.crmUserCodes = condition.selectList[0].userCode;
            }
            if (condition.opportunityEntityType && condition.opportunityEntityType.length) {
                condition.opportunityEntityTypeList = condition.opportunityEntityType;
            }
            Reflect.deleteProperty(condition, 'selectList');
            Reflect.deleteProperty(condition, 'userName');
            Reflect.deleteProperty(condition, 'opportunityEntityType');
            condition.userCode = user.userCode;
            condition.isNew = condition.isNew ? +condition.isNew : null;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });

        const handleExport = async() => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = contractList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            await getOpportunityAuth(newData);
            const excelFileList = otherUtils.sortColumnsByFixed(config.tableData.columns)?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...searchDataFormat(newData),
                ...opportunityAuth.value,
                deleteFlag: 0,
                excelTitleList
            };
            if (opportunityAuth.value.authFlag) {
                params.authFlag = opportunityAuth.value.authFlag;
            }
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            opportunityListExport(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });
        };
        const opportunityAuth = ref({
            // authFlag: false
        });
        const getOpportunityAuth = (val) => {
            return queryOpportunityRelation(val).then(res => {
                if (+res.code === 0) {
                    opportunityAuth.value = res.data;
                } else {
                    opportunityAuth.value = {};
                }
            }).catch(() => {
                opportunityAuth.value = {};
            });
        };
        const handleTransfer = () => {
            if (!contractList.selectedRows.value.length) {
                return Message.warning('请选择商机数据再进行转移');
            }
            const invalidRows = contractList.selectedRows.value.filter(it => it.opportunityEntityType !== 'overseasIntroduction__c');
            if (invalidRows.length > 0) {
                const errorTextList = invalidRows.map(row => {
                    const opportunityCode = row.opportunityCode || '';
                    const opportunityName = row.opportunityName || '';
                    return `商机编码：${opportunityCode}，商机名称：${opportunityName}，非海外业务引入类型商机`;
                }).join('<br />') + '无法转移';
                return Message.warning({
                    message: errorTextList,
                    dangerouslyUseHTMLString: true
                }); ;
            }
            setupContext.refs.transferDialogRef.show();
        };
        const saveHandle = data => {
            const params = contractList.selectedRows.value.map(it => {
                return {
                    opportunityCode: it.opportunityCode,
                    ownerCode: data.ownerCode,
                    ownerName: data.ownerName,
                    departCode: data.departCode,
                    departName: data.departName
                };
            });
            saveOpportunityTransfer(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('转移成功');
                    contractList.getList();
                    setupContext.refs.transferDialogRef.handleClose();
                }
            });
        };

        return {
            authorityCode,
            config,
            contractList,
            otpColumnConfig,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            saveHandle,
            handleTransfer,
            searchDataFormat,
            refresh,
            showColumnConfigDialog,
            handleExport
        };
    }
};
</script>

<style lang="less">
.opportunity-list {
    width: 100%;
    .opportunity-list-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .el-tabs {
        width: 100%;
    }
    .flex-layout .list-main {
        overflow: auto;
    }
    .flex-layout .table {
        overflow-y: auto;
    }
    .layout-content.opportunity-list-paper {
        padding: 0px 0px 0px;
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
}
</style>
